import { FallbackProps } from 'react-error-boundary';
const ErrorFallback = ({ error }: FallbackProps) => {
  return <p>Something went wrong: {error.message}</p>;
};

export default ErrorFallback;
